
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facebook-video-ad-creator",
      function () {
        return require("private-next-pages/facebook-video-ad-creator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facebook-video-ad-creator"])
      });
    }
  